<template>
  <div class="multi-tabs" :class="{'is-single': isSingleTab}">
    <aha-tabs-primary
      @update:activeIndex="onChangeTab"
      class="multi-tabs__header"
      :name="tabTitles[tabActiveIndex]"
      :activeIndex="tabActiveIndex"
    >
      <aha-tab-item
        v-for="(title, titleIndex) in tabTitles"
        :key="titleIndex"
        :title="getTranslateTitle(title)"
        :postTitleComponent="postTitleComponent[titleIndex]"
        :name="title"
      />
      <aha-icon
        v-if="closeable"
        name="close"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        class="multi-tabs__close-button"
        @click="onCloseButtonClicked()"
      />
    </aha-tabs-primary>
    <div v-for="(title, titleIndex) in tabTitles" :key="titleIndex" class="multi-tabs__content">
      <slot :name="`tab-${titleIndex}`" v-if="titleIndex === tabActiveIndex" />
    </div>
  </div>
</template>

<script>
import AhaTabsPrimary from './tab/TabsPrimary.vue'
import AhaTabItem from './tab/TabItem.vue'
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaTabsPrimary,
    AhaTabItem,
    AhaIcon,
  },
  props: {
    tabTitles: {
      type: Array,
      default: () => [],
    },
    defaultTabIndex: {
      type: Number,
      default: 0,
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    postTitleComponent: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tabActiveIndex: this.defaultTabIndex,
    }
  },

  computed: {
    isSingleTab() {
      return this.tabTitles?.length === 1
    },
  },

  methods: {
    onChangeTab(tabIndex) {
      this.tabActiveIndex = tabIndex
      this.$emit('onChangeTab', tabIndex)
    },

    onCloseButtonClicked() {
      this.$emit('onCloseButtonClicked')
    },

    getTranslateTitle(title) {
      if (!this.$i18nPresenter || !this.$i18nPresenter.t) {
        return title
      }
      return this.$i18nPresenter.t(title)
    },
  },
}
</script>

<style lang="scss" scoped>
.multi-tabs__close-button {
  @apply text-base-70 hover:text-primary-90;
  @apply cursor-pointer h-full;
}
.multi-tabs {
  &.is-single::v-deep {
    .aha-tab-list-wrp {
      @apply h-full flex items-center;
    }
    .aha-tab-title.active {
      @apply border-none mr-0 p-0;
      .aha-tab-title__text {
        @apply text-secondary-100;
      }
    }
  }
}
</style>
